import PropTypes from 'prop-types';
import * as React from 'react';
import {connect} from 'react-redux';

import ArrayComponent from './ArrayComponent';
import {
  getArrayContent,
  getArrayLayout,
} from 'src/js/containers/auto_layout/auto_layout_selectors';
import {ContentProperty} from 'src/js/model/auto_layout_content_schema';
import {LayoutProperty} from 'src/js/model/auto_layout_layout_schema';
import {MetadataSchema} from 'src/js/model/auto_layout_metadata_schema';

export class ArrayContainer extends React.Component {
  render() {
    const {
      arrayContent,
      arrayLayout,
      autoLayoutStateId,
      content,
      data,
      dataChanges,
      dataSets,
      expanded,
      isCollapsed,
      layout,
      metadata,
      onDataChange,
      pathToData,
      readOnly,
      rootData,
      screenId,
      textOnly,
    } = this.props;
    return (
      <ArrayComponent
        autoLayoutStateId={autoLayoutStateId}
        metadata={metadata}
        screenId={screenId}
        content={content}
        isCollapsed={isCollapsed}
        layout={layout}
        data={data}
        dataSets={dataSets}
        dataChanges={dataChanges}
        rootData={rootData}
        onDataChange={onDataChange}
        pathToData={pathToData}
        arrayContent={arrayContent}
        arrayLayout={arrayLayout}
        readOnly={readOnly}
        textOnly={textOnly}
        expanded={expanded}
      />
    );
  }
}

ArrayContainer.displayName = 'ArrayContainer';

/* eslint-disable react/no-unused-prop-types */
ArrayContainer.propTypes = {
  autoLayoutStateId: PropTypes.string.isRequired,
  content: PropTypes.instanceOf(ContentProperty).isRequired,
  dataChanges: PropTypes.objectOf(PropTypes.any),
  dataSets: PropTypes.objectOf(PropTypes.any).isRequired,
  layout: PropTypes.instanceOf(LayoutProperty).isRequired,
  rootData: PropTypes.objectOf(PropTypes.any).isRequired,
  metadata: PropTypes.instanceOf(MetadataSchema).isRequired,
  screenId: PropTypes.string.isRequired,
  isCollapsed: PropTypes.bool,
  idSuffix: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.any),
  pathToData: PropTypes.string,
  readOnly: PropTypes.bool,
  textOnly: PropTypes.bool,
  expanded: PropTypes.bool,
  onDataChange: PropTypes.func.isRequired,
  noLabel: PropTypes.bool,
};
/* eslint-enable react/no-unused-prop-types */

ArrayContainer.defaultProps = {
  data: [],
  dataChanges: undefined,
  idSuffix: '',
  isCollapsed: false,
  pathToData: '',
  readOnly: false,
  textOnly: false,
  expanded: false,
  noLabel: false,
};

export default connect((state, props) => ({
  arrayContent: getArrayContent(state, props),
  arrayLayout: getArrayLayout(state, props),
}))(ArrayContainer);
